import { render, staticRenderFns } from "./BadgeIcon.vue?vue&type=template&id=050d2629&"
import script from "./BadgeIcon.vue?vue&type=script&lang=js&"
export * from "./BadgeIcon.vue?vue&type=script&lang=js&"
import style0 from "./BadgeIcon.vue?vue&type=style&index=0&id=050d2629&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports